import React, { useState } from "react";
import classes from "./FrequentlyAskedQuestions.module.scss";
import QuestionBlock from "./QuestionBlock.tsx";
import { useTranslation } from "react-i18next";
import { IQuestion } from "./FrequentlyAskedQuestions";

const FaqOneColumn: React.FC<{ questions: IQuestion[] }> = ({ questions }) => {
  const { t } = useTranslation();
  const [openedBlockId, setOpenedBlockId] = useState<null | number>(null);

  const openBlockHandler = (id: number | null) => {
    setOpenedBlockId(id);
  };

  return (
    <div className={classes["container"]}>
      <h1 className={classes["header"]}>
        {t("frequentlyAskedQuestions.title")}
      </h1>
      <div
        className={`${classes["blocks-container"]} ${classes["one-column"]}`}
      >
        {questions.map(({ title, description, id }) => (
          <QuestionBlock
            title={title}
            description={description}
            key={id}
            id={id}
            isOpened={id === openedBlockId}
            openBlock={openBlockHandler}
          />
        ))}
      </div>
    </div>
  );
};
export default FaqOneColumn;
